import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
    UTILS_ICON_COPY,
    UTILS_ICON_DANGER,
    UTILS_ICON_DELETE,
} from '@wdx/shared/utils';
import { GET_STATUS_PENDING_CHANGES } from '../../services/form-pending-changes/form-pending-changes.helper';
import { ReactiveFormLayoutAndDefinition } from '../../models';

@Component({
    selector: 'wdx-ff-accordion-header',
    templateUrl: './form-accordion-header.component.html',
    standalone: false,
})
export class FormAccordionHeaderComponent {
    @Input() entityId!: string;
    @Input() place!: any;
    @Input() elementDefinition!: ReactiveFormLayoutAndDefinition;
    @Input() parentData!: any;
    @Input() formControlObj!: UntypedFormGroup;
    @Input() set panelInfo(val: string[]) {
        let found = false;
        val.forEach((item) => {
            const STR_ARR = item.split('-');
            if (`${STR_ARR[0]}-${this.place}` === item) {
                this.open = true;
                found = true;
            }
        });

        if (!found) {
            this.open = false;
        }
    }
    @Input() hasError = false;
    @Input() disabled = false;
    @Input() status!: string;
    @Input() readonlyMode?: boolean;

    @Output() removeItem = new EventEmitter();
    @Output() cloneItem = new EventEmitter();

    get statusInfo(): string {
        return (GET_STATUS_PENDING_CHANGES as Record<string, string>)[
            this.status
        ];
    }

    open!: boolean;
    readonly UTILS_ICON_DANGER = UTILS_ICON_DANGER;
    readonly UTILS_ICON_DELETE = UTILS_ICON_DELETE;
    readonly UTILS_ICON_COPY = UTILS_ICON_COPY;

    removeItemClicked(): void {
        this.removeItem.emit();
    }

    cloneItemClicked(): void {
        this.cloneItem.emit();
    }
}
